import { createApp } from 'vue';
import SetRoleModel from './setRoleModel';
import { RoleListItemType } from '@/type/auth';

const createModel = (list: RoleListItemType[]): void => {
  const mountNode = document.createElement('div');
  mountNode.id = 'set-role-model';

  const Instance = createApp(SetRoleModel, {
    list,
    onClose: () => {
      Instance.unmount();
      document.body.removeChild(mountNode);
    }
  });

  document.body.appendChild(mountNode);
  Instance.mount(mountNode);
};

export default createModel;
